import { apiClient } from './client'

export interface RefreshResponse {
  access_token: string
  token_type: string
}

export interface LogoutResponse {
  logout_url: string | null
}

export interface UserResponse {
  id: string
  email: string
  full_name: string
  role: string
  org_id: string
  org_code: string
}

export interface PasswordLoginResponse {
  access_token: string
  refresh_token: string
  token_type: string
}

export interface ImpersonateResponse {
  org_id: string
  org_name: string
  message: string
}

export interface CapabilitiesResponse {
  admin_access: boolean
  orgs_read: boolean
  orgs_manage: boolean
  users_manage: boolean
  groups_manage: boolean
  rls_manage: boolean
  invites_manage: boolean
  platform_rbac_read: boolean
  platform_rbac_manage: boolean
  superadmin_access: boolean
  impersonate: boolean
}

export const authAPI = {
  passwordLogin: async (email: string, password: string): Promise<PasswordLoginResponse> => {
    const response = await apiClient.post<PasswordLoginResponse>('/auth/password-login', {
      email,
      password,
    })
    return response.data
  },

  refresh: async (refreshToken: string): Promise<RefreshResponse> => {
    const response = await apiClient.post<RefreshResponse>('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data
  },

  logout: async (): Promise<LogoutResponse> => {
    const response = await apiClient.post<LogoutResponse>('/auth/logout')
    return response.data
  },

  getMe: async (): Promise<UserResponse> => {
    const response = await apiClient.get<UserResponse>('/auth/me')
    return response.data
  },

  impersonate: async (orgId: string): Promise<ImpersonateResponse> => {
    const response = await apiClient.post<ImpersonateResponse>('/auth/impersonate', {
      org_id: orgId,
    })
    return response.data
  },

  stopImpersonation: async (): Promise<void> => {
    await apiClient.post('/auth/stop-impersonation')
  },

  getCapabilities: async (): Promise<CapabilitiesResponse> => {
    const response = await apiClient.get<CapabilitiesResponse>('/auth/capabilities')
    return response.data
  },
}
